import React, { Component } from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import "./styles.css";

const filterList = ['is_award_winner', 'is_unclaimed', 'story_count'];

const CurrentRefinements = ({ items, refine, createURL }) => {
  //console.log('CurrentRefinements', items);
  const SHOW = items.length > 1;
  const list = items.map(item => {

    if (filterList.includes(item.id)) {
      let label = item.label;
      if (item.id === 'story_count') {
        label = item.label.replace("story_count", "Stories");
      }
      return (
        <React.Fragment>
              <li key={item.label} className="refine-item" onClick={event => {
                event.preventDefault();
                refine(item.value);
              }}>
                {label}
                <a href="#" className="remove" tabIndex="-1" title="Remove">x
              </a>
            </li>
        </React.Fragment>
      );
    }

     if (item.items) return (
         <React.Fragment>
             {item.items.map(nested => (
               <li key={nested.label} className="refine-item" onClick={event => {
                 event.preventDefault();
                 refine(nested.value);
               }}>
                 {nested.label}
                 <a href="#" className="remove" tabIndex="-1" title="Remove">x
               </a>
             </li>
             ))}
         </React.Fragment>
       )
   })
  return (
    SHOW ? <ul className="refinement-list">{list}</ul> : null
 );
}



const CurrentRefinementList = connectCurrentRefinements(CurrentRefinements);
export default CurrentRefinementList;
